import { AdvisorUiConfig, PRDUIConfiguration } from '@blk/aw-bff-typescript-models';
import { awBffConfigApi } from './Base';

export interface ClientConfigurationParams {
  configurationDirectory?: string;
  pkg: string;
  viewAs?: string;
}

export function getAWPRDConfiguration(params: ClientConfigurationParams) {
  const path = '/ui-config/prd';
  return awBffConfigApi.get<PRDUIConfiguration>(path, { params });
}
export function getAWAdvisorConfigurationApi(params: ClientConfigurationParams) {
  const path = '/ui-config/advisor';
  return awBffConfigApi.get<AdvisorUiConfig>(path, { params });
}
